import PlayCircleOutline from "@mui/icons-material/PlayCircleOutline";
import LoaderDots from "components/LoaderDots";
import { Status } from "types/Status";
import ButtonBase from "@mui/material/ButtonBase";
import { styled, type ButtonBaseProps } from "@mui/material";

const Image = styled("img")({
  width: "100%",
  height: "100%",
  borderRadius: 4,
});

interface ExerciseRecordingVideoPreviewProps {
  status: Status;
  src: string | undefined;
  onClick: ButtonBaseProps["onClick"];
  sx?: ButtonBaseProps["sx"];
}

function ExerciseRecordingVideoPreview(props: ExerciseRecordingVideoPreviewProps) {
  const { status, src, sx, ...rest } = props;

  return (
    <ButtonBase
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: 30,
        width: 30,
        borderRadius: "4px",
        backgroundColor: "grey.60",
        ...sx,
      }}
      disabled={status !== "success"}
      {...rest}
    >
      {status === "fetching" ? (
        <LoaderDots size="small" color="secondary" />
      ) : (
        <>
          <Image src={src} alt="video-thumbnail" className="sr-no-capture" />
          <PlayCircleOutline
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "#FFF",
            }}
          />
        </>
      )}
    </ButtonBase>
  );
}

export default ExerciseRecordingVideoPreview;
